import { getCurrentLanguage } from "../shared/language";
import { COUNTRY_COORDINATES } from "./country-coordinates";

const COUNTRY_LOOKUP_URL = "/cdn-cgi/trace";
const LOCATION_CACHE_KEY = "mx-nearest-office-location-v1";
const LOCATION_CACHE_TTL = 30 * 60 * 1000;
const LOOKUP_TIMEOUT = 3000;

const OFFICES = [
  {
    name: "Ukraine",
    address: "Lutsk, 4 Rivnenska St., Strumivka, Lutsk, 45603",
    uk: {
      name: "Україна",
      address: "Луцьк, вул. Рівненська, 4, Струмівка, 45603",
    },
    pl: {
      name: "Ukraina",
      address: "Łuck, ul. Riwneńska 4, Strumiwka, 45603",
    },
    phone: "+380 (332) 78 95 00",
    phoneUrl: "tel:+380332789500",
    email: "info@modern-expo.com",
    latitude: 50.747,
    longitude: 25.325,
  },
  {
    name: "Poland",
    address: "Lublin, Ludwik Spiess St., 3 20-270",
    uk: {
      name: "Польща",
      address: "Люблін, вул. Людвіка Спісса, 3, 20-270",
    },
    pl: {
      name: "Polska",
      address: "Lublin, ul. Ludwika Spiessa 3, 20-270",
    },
    phone: "+48 (81) 744 50 50",
    phoneUrl: "tel:+48817445050",
    email: "biurohandlowe@modern-expo.pl",
    latitude: 51.246,
    longitude: 22.569,
  },
  {
    name: "United Kingdom",
    address: "London, Headlands House 1 Kings Court, Kettering",
    uk: {
      name: "Велика Британія",
      address: "Лондон, Headlands House 1 Kings Court, Кеттерінг",
    },
    pl: {
      name: "Wielka Brytania",
      address: "Londyn, Headlands House 1 Kings Court, Kettering",
    },
    phone: "+44 (7535) 825 414",
    phoneUrl: "tel:+447535825414",
    email: "uk.sales@modern-expo.com",
    latitude: 51.507,
    longitude: -0.127,
  },
  {
    name: "Cyprus",
    address: "Nicosia, Dadlaw Business Centre, 3 Thasou St, Office 313",
    uk: {
      name: "Кіпр",
      address: "Нікосія, Dadlaw Business Centre, вул. Тасу, 3, офіс 313",
    },
    pl: {
      name: "Cypr",
      address: "Nikozja, Dadlaw Business Centre, ul. Thasou 3, biuro 313",
    },
    phone: "+971 (66) 815 0070",
    phoneUrl: "tel:+971668150070",
    email: "info@coastrock.cy",
    latitude: 35.185,
    longitude: 33.382,
  },
  {
    name: "Germany",
    address: "Berlin, Gartenfelder Str. 15-37, 13599",
    uk: {
      name: "Німеччина",
      address: "Берлін, Gartenfelder Str. 15-37, 13599",
    },
    pl: {
      name: "Niemcy",
      address: "Berlin, Gartenfelder Str. 15-37, 13599",
    },
    phone: "+49 (171) 22 21 293",
    phoneUrl: "tel:+491712221293",
    email: "officeberlin@modern-expo.de",
    latitude: 52.52,
    longitude: 13.4,
  },
  {
    name: "UAE",
    address: "Dubai, Barsha Heights, Tameem House, Office 1007",
    uk: {
      name: "ОАЕ",
      address: "Дубай, Barsha Heights, Tameem House, офіс 1007",
    },
    pl: {
      name: "ZEA",
      address: "Dubaj, Barsha Heights, Tameem House, biuro 1007",
    },
    phone: "+971 (66) 815 0070",
    phoneUrl: "tel:+971668150070",
    email: "dmytro.stepanov@modern-expo.com",
    latitude: 25.204,
    longitude: 55.27,
  },
  {
    name: "France",
    address: "Antony, 4 Rue Alexis de Tocqueville 92160",
    uk: {
      name: "Франція",
      address: "Антоні, 4 Rue Alexis de Tocqueville 92160",
    },
    pl: {
      name: "Francja",
      address: "Antony, 4 Rue Alexis de Tocqueville 92160",
    },
    phone: "+33 (7) 67 03 03 35",
    phoneUrl: "tel:+33767030335",
    email: "contact@modern-expo.com",
    latitude: 48.753,
    longitude: 2.297,
  },
];

function getDistance(latitudeA, longitudeA, latitudeB, longitudeB) {
  const earthRadius = 6371;
  const radians = Math.PI / 180;
  const latitudeDistance = Math.sin(((latitudeB - latitudeA) * radians) / 2);
  const longitudeDistance = Math.sin(((longitudeB - longitudeA) * radians) / 2);

  return (
    earthRadius *
    2 *
    Math.asin(
      Math.sqrt(
        latitudeDistance * latitudeDistance +
          Math.cos(latitudeA * radians) *
            Math.cos(latitudeB * radians) *
            longitudeDistance *
            longitudeDistance
      )
    )
  );
}

function updateOffice(office) {
  const language = getCurrentLanguage();
  const officeText = language === "uk" || language === "pl" ? office[language] || office : office;

  document.querySelectorAll(".section__contact-right").forEach((wrapper) => {
    const name = wrapper.querySelector("[data-office-name]");
    if (name) name.textContent = officeText.name;

    const address = wrapper.querySelector("[data-office-address]");
    if (address) address.textContent = officeText.address;

    const phoneLink = wrapper.querySelector("[data-office-phone]");
    if (phoneLink) {
      phoneLink.href = office.phoneUrl;
      const phoneText = phoneLink.querySelector("div") || phoneLink;
      phoneText.textContent = office.phone;
    }

    const emailLink = wrapper.querySelector("[data-office-email]");
    if (emailLink) {
      emailLink.href = `mailto:${office.email}?subject=Contact%20from%20website`;
      const emailText = emailLink.querySelector("div") || emailLink;
      emailText.textContent = office.email;
    }
  });
}

function getCoordinates(location) {
  const parseCoordinate = (value) =>
    typeof value === "number" || (typeof value === "string" && value.trim()) ? Number(value) : NaN;
  const latitude = parseCoordinate(location?.latitude);
  const longitude = parseCoordinate(location?.longitude);
  if (
    !Number.isFinite(latitude) ||
    !Number.isFinite(longitude) ||
    Math.abs(latitude) > 90 ||
    Math.abs(longitude) > 180
  ) {
    return null;
  }

  return { latitude, longitude };
}

function getCachedLocation() {
  try {
    const cached = JSON.parse(window.sessionStorage.getItem(LOCATION_CACHE_KEY));
    const age = Date.now() - cached?.timestamp;
    if (Number.isFinite(age) && age >= 0 && age < LOCATION_CACHE_TTL) {
      return getCoordinates(cached);
    }
  } catch {}

  return null;
}

async function getVisitorLocation() {
  const cached = getCachedLocation();
  if (cached) return cached;

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), LOOKUP_TIMEOUT);

  try {
    // Same-origin Cloudflare endpoint: the visitor's country, no third party involved.
    const response = await fetch(COUNTRY_LOOKUP_URL, {
      signal: controller.signal,
      credentials: "omit",
      cache: "no-store",
    });
    if (!response.ok) return null;

    const country = (await response.text()).match(/^loc=([A-Z]{2})$/m)?.[1];
    const location = COUNTRY_COORDINATES.get(country);
    if (!location) return null;

    try {
      window.sessionStorage.setItem(
        LOCATION_CACHE_KEY,
        JSON.stringify({ ...location, timestamp: Date.now() })
      );
    } catch {}

    return location;
  } catch {
    return null;
  } finally {
    window.clearTimeout(timeout);
  }
}

let initialized = false;

async function initNearestOffice() {
  if (initialized || !document.querySelector(".section__contact-right")) return;
  initialized = true;

  const location = await getVisitorLocation();
  if (!location) return;

  const { latitude, longitude } = location;
  const nearestOffice = OFFICES.reduce((currentNearest, office) =>
    getDistance(latitude, longitude, currentNearest.latitude, currentNearest.longitude) <
    getDistance(latitude, longitude, office.latitude, office.longitude)
      ? currentNearest
      : office
  );

  updateOffice(nearestOffice);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initNearestOffice, { once: true });
} else {
  initNearestOffice();
}
